export enum ProfileErrorCodes {
  OverUserProfileCount = 'OverUserProfileCount',
  NicknameAlreadyExists = 'NicknameAlreadyExists',
  NicknameReserved = 'NicknameReserved',
  NicknameRestricted = 'NicknameRestricted',
}
